import { Card, cn } from '@heltarchat/ui';
import React, { memo } from 'react';

import StyledComponentProps from 'utils/types/styled-components-type';
import { Modal } from '../AlltypeStyledComponent';

interface Props extends StyledComponentProps {
  children?: React.ReactNode;
  classNameModal?: string;
  classNameCard?: string;
}

export const ModalWithCard = memo((props: Props) => {
  return (
    <Modal
      className={cn('', props.classNameModal)}
      background='var(--heltar-bg-modal-overlay)'
      zindex='1'
    >
      <Card
        className={cn(
          'border-none p-4 w-auto h-auto overflow-hidden shadow-[0_17px_50px_rgba(11,20,26,0.19),0_12px_15px_rgba(11,20,26,0.24)]',
          props.classNameCard,
        )}
      >
        {props.children}
      </Card>
    </Modal>
  );
});
